import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { IEtiquetas } from "../../../shared/services/api/cadastros/ProdutosService";
import { useState } from "react";
const bwipjs = require("bwip-js");

const gerarCodigoBarras = async (ean: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    try {
      bwipjs.toCanvas(canvas, {
        bcid: "code39",
        text: ean,
        scale: 3,
        height: 10,
        includetext: true,
        textxalign: "center",
      });
      resolve(canvas.toDataURL("image/png"));
    } catch (err) {
      reject(err);
    }
  });
};

const REtiquetasGrand = async (dados: IEtiquetas[], qtd: number) => {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const colunasPorLinha = 1; // Altere este valor para definir o número de colunas
  const tabelaEtiquetas: any[] = [];

  const etiquetasProcessadas = await Promise.all(
    dados.map(async (item) => {
      //const codigoBarras = await gerarCodigoBarras('2025');
      //  gerarCodigoBarras("123456789").then(setImagem).catch(console.error);
      const codigo = await gerarCodigoBarras("123456");
      return {   
        stack: [
          { text:`${item.descricao} ${item.fabrica}`, fontSize: 14, alignment: "center" },
          //{ text: `${item.descricao}`, fontSize: 12, alignment: "center" },
          { image: codigo, width: 60, fontSize: 12, alignment: "center" },
          { text: '------------------------------------------------------------------', margin: [20, 0, 0, 0], fontSize: 8, alignment: "left" },
          { text: 'Quantidade', margin: [20, 0, 0, 0], fontSize: 14, alignment: "left" },
          { text: `${qtd}`, margin: [16, 0, 0, 0],  fontSize: 20, alignment: "left" },
        ],
        margin: [0, 0, 0, 0],
        border: [false, false, false, false],
      };
    })      
  );  

  // Agrupa as etiquetas em linhas com 3 colunas
  for (let i = 0; i < etiquetasProcessadas.length; i += colunasPorLinha) {
    tabelaEtiquetas.push(etiquetasProcessadas.slice(i, i + colunasPorLinha));
  }

  const docDefinition: any = {
    pageSize: { width: 288, height: 100  },
    pageMargins: [0, 0, 80, 0],   
    content: [
      {    
        table: {
          widths: Array(colunasPorLinha).fill("*"), // Define colunas de tamanhos iguais
          body: tabelaEtiquetas,
        },
      },
    ],
  };

  const pdfDocGenerator = pdfMake.createPdf(docDefinition);
  pdfDocGenerator.open();
};

export default REtiquetasGrand;

